import { createAction, props } from '@ngrx/store';
import { CalculateOptimalSystemRequest, CalculateOptimalSystemResponse, CalculateSystemComparisonResponse } from '../../shared/interfaces';

export namespace ResultsActions {
    export const calculateOptimalSystem = createAction('[RESULTS] Calculate System', props<CalculateOptimalSystemRequest>());
    export const calculateOptimalSystemSuccess = createAction(
        '[RESULTS] Calculate System Selection Success',
        props<CalculateOptimalSystemResponse>()
    );
    export const calculateSystemComparisonSuccess = createAction(
        '[RESULTS] Calculate System Simulation Success',
        props<CalculateSystemComparisonResponse>()
    );
    export const calculateSystemFailure = createAction('[RESULTS] Calculate System Failure', props<{ error: string }>());
}
